import { Box, Typography, Divider, Modal } from '@mui/material';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { useEffect } from 'react';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import PermissionController from '../controller/permission.controller';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import PermissionHeader from './components/permission.header';
import PermissionTable from './components/permission.table';
import PermissionModalCreate from './components/permission.modal.create';
import PermissionModalUpdate from './components/permission.modal.update';
import useScreenWidth from '../../../hooks/use-page-width';

const PermissionPage = () => {
  const ctrl = PermissionController();
  const alert = CusttomAlertController();
  const width = useScreenWidth();

  useEffect(() => {
    ctrl.getData(true, ctrl.filter);
  }, []);

  const modalContent =
    ctrl.activeModal?.name === 'CREATE' ? (
      <PermissionModalCreate
        loading={ctrl.loading}
        message={ctrl.message}
        onClose={() => ctrl.onHandleModal(null)}
        onSubmit={ctrl.onSubmitCreate}
      />
    ) : ctrl.activeModal?.name === 'UPDATE' ? (
      <PermissionModalUpdate
        loading={ctrl.loading}
        message={ctrl.message}
        defaultValues={ctrl.formUpdate}
        onClose={() => ctrl.onHandleModal(null)}
        onSubmit={ctrl.onSubmitUpdate}
      />
    ) : null;

  return (
    <>
      <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການສິດທິ</Typography>

      <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: '15px' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f4f4',
            borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
          }}
        >
          <PermissionHeader
            filter={ctrl.filter}
            onFilterChange={ctrl.onFilterChange}
            handleOpenDialog={() => ctrl.onHandleModal({ name: 'CREATE' })}
          />

          <Divider sx={{ backgroundColor: '#D9D9D9' }} />

          <Typography
            fontSize={18}
            sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
          >
            <VpnKeyOutlinedIcon />
            <Typography marginLeft="10px">ຈັດການສິດທິການນຳໃຊ້</Typography>
          </Typography>

          <PermissionTable ctrl={ctrl} alert={alert} />
        </Box>
      </Box>

      <Modal
        open={ctrl.activeModal != null}
        onClose={() => ctrl.onHandleModal(null)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
      >
        <Box
          sx={{
            bgcolor: 'white',
            width: '100%',
            maxWidth: '900px',
            borderRadius: '12px',
            maxHeight: { xs: '90vh', md: '800px' },
            overflow: 'auto',
          }}
        >
          {modalContent}
        </Box>
      </Modal>

      <CustomAlertModal ctrl={alert} />
    </>
  );
};

export default PermissionPage;
